import React from 'react'
import Videocam from '@material-ui/icons/Videocam'
import VideocamOff from '@material-ui/icons/VideocamOff'
import { FlexContainer, Paragraph, Button } from 'heliocor-ui'
import { useTranslation } from 'react-i18next';
import 'styled-components/macro'

import { UploadDocument } from './UploadDocument'
import { CameraComponent } from '../../../common/camera/Camera'


const UpperMessage = ({text, changeView, icon, props}) =>
    <FlexContainer justifyContent='flex-end' alignItems='center' >
        <Button
            type='light'
            onClick={changeView}
            size='small' 
            fixDimension={{height:'32px', width:'auto'}}
            value={
                <FlexContainer justifyContent='flex-end' alignItems='center'>
                    {React.createElement(icon, props)}
                    <span css='padding-left: .5rem; min-width: 4rem;'>{text}</span>
                </FlexContainer>
            } 
        />
    </FlexContainer>

const MandatoryCameraButNotSupported = ({text}) =>  
    <FlexContainer column alignItems='center' justifyContent='center' margin='4rem'>
        <Paragraph textAlign='center' value={text} />
    </FlexContainer>


const UploadSelfie = ({
  documentConfig,
  handleUpload,
  selfieMustBeTakenWithCamera,
  isCameraNeeded,
}) => {
  	const { t } = useTranslation()
  	const INITIAL_METHOD = isCameraNeeded ? "CAMERA" : "UPLOAD";
  	const [method, setMethod] = React.useState(INITIAL_METHOD);

  	const isVideoSelfie = documentConfig.name === "VIDEO_SELFIE"

  	const methodViews = {
  	  	UPLOAD: {
  	  	  	component: UploadDocument,
  	  	  	props: {
  	  	  		documentConfig,
      	  		handleUpload,
      	  		containerMargin: "0 2rem",
      		}
    	},
    	CAMERA: {
    	  	component: CameraComponent,
    	  	props: {
    	  	  	documentConfig,
    	  	  	handleUpload,
    	  	  	isVideoSelfie,
      		}
    	},
  	};

  const methodMessages = {
    UPLOAD: {
        component: UpperMessage,
        props: {
        	changeView: () => setMethod("CAMERA"),
        	text: t("warning.doSelfie"),
        	icon: VideocamOff,
        	props: {
        		fontSize: "small",
        		style: { color: "#C9C9C9" },
        	},
        }    
    },
    CAMERA: {
        component: UpperMessage,
        props: {
        	changeView: () => setMethod("UPLOAD"),
        	text: t("warning.uploadPhoto"),
        	icon: Videocam,
        	props: {
        		fontSize: "small",
        	},
        },
    }
  }

  const view = methodViews[method];
  const message = methodMessages[method];

  if (selfieMustBeTakenWithCamera && !isCameraNeeded) {
	return <MandatoryCameraButNotSupported text={t('warning.cameraNotSupportedAndNeeded')}/>
  }

  return (
    <FlexContainer column>
    	{message &&
    		!selfieMustBeTakenWithCamera &&
    		React.createElement(message.component, message.props)}
    	{React.createElement(view.component, view.props)}
    </FlexContainer>
  );
};

export { UploadSelfie }